import { PermissionsProtectedRoute } from 'client/routes/PermissionsProtectedRoute';
import { Navigate, RouteObject } from 'react-router-dom';
import React from 'react';
import { TAGS_PERMISSIONS } from './permissions/Tags';

const TagsPage = React.lazy(() => import('./containers/TagsPage'));

export const tagsRoutes: RouteObject = {
  path: 'tags',
  element: (
    <PermissionsProtectedRoute
      pageId={TAGS_PERMISSIONS.pageId}
      currentPath="/tags"
    />
  ),
  children: [
    {
      path: '',
      element: (
        <React.Suspense fallback={undefined}>
          <TagsPage />
        </React.Suspense>
      ),
    },
    { path: '*', element: <Navigate to="/404" /> },
  ],
};
